import { AppState } from '../store';

export const usersSelector = ({ Users: { users } }: AppState) => {
  return users;
};

export const usersOrderSelector = ({ Users: { orderBy, order } }: AppState) => {
  return { orderBy, order };
};
